import React, { useState, useEffect } from 'react';
import { Container, Typography, Button, CircularProgress, Alert, TextField } from '@mui/material';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { buildApiUrl } from '../../config/api';

export default function WelcomePage() {
    const { uuid } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get('token');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [tokenValid, setTokenValid] = useState(null);
    const [nickname, setNickname] = useState('');
    const [accessKey, setAccessKey] = useState('');
    const [accessKeyError, setAccessKeyError] = useState('');

    useEffect(() => {
        fetch(buildApiUrl(`qrcode/${uuid}?token=${token}`))
            .then(resp => {
                if (!resp.ok) throw new Error('QR code ou token inválido ou expirado.');
                return resp.json();
            })
            .then(data => {
                setTokenValid(true);
                setNickname(data.nickname);
                localStorage.setItem(`qrcode_${uuid}`,
                    JSON.stringify({ participant_id: data.participant_id, envelope_id: data.envelope_id, nickname: data.nickname })
                );
                // Se já existe chave salva, preenche o campo
                const savedKey = localStorage.getItem(`access_key_${uuid}`);
                if (savedKey) setAccessKey(savedKey);
            })
            .catch(() => {
                setError('QR code ou token inválido ou expirado.');
                setTokenValid(false);
            })
            .finally(() => setLoading(false));
    }, [uuid, token]);

    if (loading) return <Container maxWidth="sm" sx={{ mt: 8, textAlign: 'center' }}><CircularProgress /></Container>;
    if (error || tokenValid === false) return <Container maxWidth="sm" sx={{ mt: 8, textAlign: 'center' }}><Alert severity="error">{error || 'Token inválido. Acesso não autorizado.'}</Alert></Container>;
    if (tokenValid === null) return null;

    const handleAdvance = () => {
        setAccessKeyError('');
        if (!accessKey.trim()) {
            setAccessKeyError('Informe a chave de acesso');
            return;
        }
        if (accessKey.trim() !== String(nickname)) {
            setAccessKeyError('Chave de acesso incorreta.');
            return;
        }
        localStorage.setItem(`access_key_${uuid}`, accessKey.trim());
        // Salva também no objeto qrcode para uso consistente nas outras páginas
        const qrcodeData = localStorage.getItem(`qrcode_${uuid}`);
        let parsed = {};
        try { parsed = JSON.parse(qrcodeData) || {}; } catch {}
        parsed.access_key = accessKey.trim();
        localStorage.setItem(`qrcode_${uuid}`, JSON.stringify(parsed));
        navigate(`/envelope/${uuid}?token=${token}`);
    };

    return (
        <Container maxWidth="sm" sx={{ mt: 8, textAlign: 'center' }}>
            <Typography variant="h4" gutterBottom>Bem-vindo(a) ao experimento!</Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
                Agradecemos muito a sua participação.<br /><br />
                Nas próximas telas você pode incluir o texto da sua resposta e as fotos do envelope e da resposta original escrita à mão.<br /><br />
                Para iniciar, informe a chave de acesso recebida.
            </Typography>
            <TextField
                label="Chave de acesso"
                value={accessKey}
                onChange={e => setAccessKey(e.target.value)}
                error={!!accessKeyError}
                helperText={accessKeyError || ''}
                sx={{ mb: 2, width: '100%' }}
                inputProps={{ maxLength: 10, style: { textAlign: 'center', fontSize: 22, letterSpacing: 2 } }}
            />
            <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={handleAdvance}
                sx={{ mt: 2 }}
            >
                Avançar
            </Button>
        </Container>
    );
}
